

<div class="container-fluid dashboard-topbard">
    <div class="row">
        <div class="col-lg-2 col-sm-2">
            <div class="dashboard-logo mt-2 white-text pb-2"> <img src="../../../assets/image/admin-logo.png"> </div>
        </div>
        <div class="col-lg-10 col-sm-10">
            <ul class="topbar-menu float-right mt-3 white-text">
                <li><img src=""> Welcome to Admin Panel</li>
                <li class="ml-2 mr-2"><img src=""> | </li>
                <li class="dashboard-dropdown-link"><a href="#">My Account</a>
                    
                    <ul class="dashboard-dropdown z-index-top">
                        <li><a href="#">Profile</a></li>
                        <li><a href="#">Change Password</a></li>
                    </ul>
  
                </li>
  
            </ul>
        </div>
    </div>
</div>

<div class="dashboard-full-width">
    <div class="">
            <div class="main-container-dashboard">


                
              <app-lab-sidebar></app-lab-sidebar>
                


                    <div class="dashboard-container-right">
                    
                            <div class="main-container">
                                

                                <!-- table listing -->
                                <div class="row">
                                    <div class="col-lg-12">
                                        <h3 class="dashboard-heading-1">Listing</h3>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-lg-12 m-6">
                                        
                                        <table class="table dashboard-font-12">
                                            <thead class="thead-dark">
                                              <tr>
                                                <th scope="col">S/N</th>
                                                <th scope="col">Company Name</th>
                                                <th scope="col">Tax Payer ID</th>
                                                <th scope="col">Date Generated</th>
                                                <th scope="col">Invoice ID</th>
                                                <th scope="col">View & Action</th>
                                              </tr>
                                            </thead>
                                            <tbody class="dashboard-bg-white">
                                              <tr>
                                                <th scope="row">1</th>
                                                <td>Waelchi, Hane and Schoen</td>
                                                <td>CMP7330485420</td>
                                                <td>Jun 10, 2021</td>
                                                <td>Self Service Portal</td>
                                                <td><button class="btn-view">View</button></td>
                                              </tr>
                                              <tr>
                                                <th scope="row">2</th>
                                                <td>Waelchi, Hane and Schoen</td>
                                                <td>CMP7330485420</td>
                                                <td>Jun 10, 2021</td>
                                                <td>Self Service Portal</td>
                                                <td><button class="btn-view">View</button></td>
                                              </tr>
                                              <tr>
                                                <th scope="row">3</th>
                                                <td>Waelchi, Hane and Schoen</td>
                                                <td>CMP7330485420</td>
                                                <td>Jun 10, 2021</td>
                                                <td>Self Service Portal</td>
                                                <td><button class="btn-view">View</button></td>
                                              </tr>
                                              <tr>
                                                <th scope="row">4</th>
                                                <td>Waelchi, Hane and Schoen</td>
                                                <td>CMP7330485420</td>
                                                <td>Jun 10, 2021</td>
                                                <td>Self Service Portal</td>
                                                <td><button class="btn-view">View</button></td>
                                              </tr>
                                              <tr>
                                                <th scope="row">5</th>
                                                <td>Waelchi, Hane and Schoen</td>
                                                <td>CMP7330485420</td>
                                                <td>Jun 10, 2021</td>
                                                <td>Self Service Portal</td>
                                                <td><button class="btn-view">View</button></td>
                                              </tr>                                             
                                            </tbody>
                                          </table>
                                        
                                          

                                        
                                        
                                          

                                    </div>
                                </div>



                                <!-- form section start -->





                                

                                <div class="row">
                                    <div class="col-6 dashboard-bg-white border-radius-5 mx-auto p-all">

                                        <h3 class="dashboard-heading-1">Form</h3>
                                        
                                        <form>
                                            <div class="form-row font-12">
                                              <div class="form-group col-md-6">
                                                <label for="inputEmail4">Email</label>
                                                <input type="email" class="form-control" id="inputEmail4" placeholder="Email">
                                              </div>
                                              <div class="form-group col-md-6">
                                                <label for="inputPassword4">Password</label>
                                                <input type="password" class="form-control" id="inputPassword4" placeholder="Password">
                                              </div>
                                            </div>
                                            <div class="form-group">
                                              <label for="inputAddress">Address</label>
                                              <input type="text" class="form-control" id="inputAddress" placeholder="1234 Main St">
                                            </div>
                                            <div class="form-group">
                                              <label for="inputAddress2">Address 2</label>
                                              <input type="text" class="form-control" id="inputAddress2" placeholder="Apartment, studio, or floor">
                                            </div>
                                            <div class="form-row">
                                              <div class="form-group col-md-6">
                                                <label for="inputCity">City</label>
                                                <input type="text" class="form-control" id="inputCity">
                                              </div>
                                              <div class="form-group col-md-4">
                                                <label for="inputState">State</label>
                                                <select id="inputState" class="form-control">
                                                  <option selected>Choose...</option>
                                                  <option>...</option>
                                                </select>
                                              </div>
                                              <div class="form-group col-md-2">
                                                <label for="inputZip">Zip</label>
                                                <input type="text" class="form-control" id="inputZip">
                                              </div>
                                            </div>
                                            <div class="form-group">
                                              <div class="form-check">
                                                <input class="form-check-input" type="checkbox" id="gridCheck">
                                                <label class="form-check-label" for="gridCheck">
                                                  Check me out
                                                </label>
                                              </div>
                                            </div>
                                            <button type="submit" class="btn btn-primary">Sign in</button>
                                          </form>
                                       

                                    </div>
                                </div>






                            </div>
                        
                    </div>

            </div>
    </div>
</div>





